import { render, staticRenderFns } from "./PlanSuggestions.vue?vue&type=template&id=096b72da&scoped=true"
import script from "./PlanSuggestions.vue?vue&type=script&lang=js"
export * from "./PlanSuggestions.vue?vue&type=script&lang=js"
import style0 from "./PlanSuggestions.vue?vue&type=style&index=0&id=096b72da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b72da",
  null
  
)

export default component.exports